module.exports = __webpack_public_path__ + "img/slide-2.4e7f870e.webp";